import { FC } from 'react';
import { Controller, useFormContext } from 'react-hook-form';
// components
import NumericFormatInput, {
  IProps as INumericFormatInputProps,
} from 'components/inputs/numeric-format-input';

export interface IProps extends INumericFormatInputProps {
  withError?: boolean;
}

const NumericFormatInputController: FC<IProps> = ({ name, withError, defaultValue, ...rest }) => {
  const { control } = useFormContext();

  return (
    <Controller
      render={({ field: { value, onChange }, fieldState: { error } }) => {
        const onInputChange = (val: string | number) => {
          onChange(val ?? null);
        };

        return (
          <NumericFormatInput
            name={name}
            value={value}
            error={!!error}
            onChange={onInputChange}
            helperText={withError ? error?.message || ' ' : ' '}
            {...rest}
          />
        );
      }}
      name={name}
      control={control}
      defaultValue={defaultValue}
    />
  );
};

export default NumericFormatInputController;
